<template>
  <div>
    <div class="page-title">New Timeline</div>
    <Form
      v-if="form"
      v-model="form"
      :submit="create"
      btnText="Add Timeline"
    />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.timeline-lists.page";
export default {
  components: { Form },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.TimelineList.new();
      this.form = data;
    },
    async create() {
      await this.$api.TimelineList.create(this.form);
      this.$router.push("/widgets/timeline-lists");
    },
  },
};
</script>

<style></style>
